import styles from "./PPTPollsPage.module.css";
import {
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    BLANK_REGEX_WRAPPED,
    BLANK_REGEX_WRAPPED_NEW,
    QUESTION_TYPES
} from "../../utils/constants";
import presentPageClasses from "../PresentationPage/Presentation.module.css";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";
import {isGeneralSA, questionCodeToName} from "../../utils/questionUtils";
import {getQuestionWeightage, getShortName, questionHasWeightage,} from "../../utils/helpers";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import ViewLiveRespCountChart from "../ReleaseActivityPage/ViewLiveRespCountChart";
import responseClasses from "../JoinQuizPage/ClassResult.module.css";
import WordCloudResult from "../JoinQuizPage/WordCloudResult";
import ViewLiveRespRK from "../ReleaseActivityPage/ViewLiveRespRK";
import ViewLiveRespMH from "../ReleaseActivityPage/ViewLiveRespMH";
import ViewLiveRespOE from "../ReleaseActivityPage/ViewLiveRespOE";
import React, {Fragment, useEffect, useState} from "react";
import {QRCodeCanvas} from "qrcode.react";
import {useClassResultsAnalysisManager} from "../../hooks/useClassResultsAnalysisManager";
import {useParams} from "react-router-dom";
import {PollApiCalls} from "../../apis/PollApiCalls";
import { ReactComponent as NoResultIllustration } from "../../images/notGradedAttendance.svg";
import {LatexInline} from "../../components/Tiptap/latexParser";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import Skeleton from "react-loading-skeleton";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {useConfig} from "../../hooks/useConfig";
import { Accordion } from '@base-ui/react/accordion';
import { useTranslation } from "react-i18next";


export default function SlideQuestionTemplate({ }) {
    const { t } = useTranslation();
    const {getPublishedPollDataFromKey, } = PollApiCalls();
    const {getResponsesDataByPoll} = ResponseApiCalls();
    let {pollCode, pollKey, serialNo} = useParams();
    const config = useConfig();
    let shortName = getShortName();
    const HOST = shortName + '.' + config.host_url;
    const [dataReady, setDataReady] = useState(false);
    const [pollData, setPollData] = useState({});
    const [poll, setPoll] = useState({});
    const [question, setQuestion] = useState({});
    const [liveResponsesData, setLiveResponsesData] = useState([]);
    const {responseCountData} = useClassResultsAnalysisManager(pollData , liveResponsesData);
    const {getRedirectUrl, canHavePollCode} = useSynLMSConfiguration();
    const [liveResponses, setLiveResponses] = useState();



    useEffect(() => {
        let promise1 = getPublishedPollDataFromKey(pollKey, pollCode).then(res => {
            let {questions=[], poll={}} = res;
            setPollData(res);
            setPoll(poll);
            setQuestion(questions.find(q => q.serialNo === parseInt(serialNo)));
        });

        let promise2 = getResponsesDataByPoll(pollKey, pollCode).then(res => {
            setLiveResponsesData(res);
        });

        Promise.all([promise1, promise2]).finally(() => {
            setDataReady(true);
        });


    }, []);


    useEffect(() => {
        if (responseCountData && responseCountData.length > 0) {
            setLiveResponses(responseCountData[serialNo - 1]);
        }

    }, [responseCountData]);

    if (!dataReady) {
        return (
            <div className={`${styles.canvas}`}>
                <Skeleton borderRadius={10} inline={true} width={"100%"} height={"100%"}/>
            </div>
        );
    }


    let redirectUrl = getRedirectUrl(poll);
    let isPollCodeVisible = canHavePollCode(poll);


    const renderLeftPortion = () => {
        return (
            <div
                className={`${styles.canvasLeftPart} ${styles.column}`}
                style={{height: "100%", alignItems: "center", position: "relative"}}
            >
                <div style={{flex: 1}}/>
                {!!redirectUrl &&
                    <>
                        <span
                            style={{fontSize: 18, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}
                        >{poll.pollTitle}</span>
                        {isPollCodeVisible &&
                            <>
                                <span className={styles.canvasJoinText}>{t("poll.joinAt", {url: HOST})}</span>
                                <span className={styles.pollCodeBadge}>{t("poll.useCode", {code: pollCode})}</span>
                            </>
                        }


                        <div className={styles.QRCodeWrapper} style={{marginTop: 25}}>
                            <QRCodeCanvas
                                id={`QR${pollCode}`}
                                size={130}
                                renderAs="canvas"
                                value={redirectUrl}
                            />
                        </div>
                    </>
                }

                {!redirectUrl &&
                    <span style={{fontSize: 25, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}>
                        {poll.pollTitle}
                    </span>
                }

                <div style={{flex: 1}}/>
            </div>
        );
    }

    const renderTitle = () => {

        if (question.questionType !== QUESTION_TYPES.FITB.name) {
            return <span><LatexInline>{question.queTitle}</LatexInline></span>;
        }
        return (
            <span className={styles.row} style={{flexWrap: "wrap"}}>
               {question.queTitle.split(question.hasBlankRestriction ? BLANK_REGEX_WRAPPED_NEW : BLANK_REGEX_WRAPPED).map((str, i) => { // /(\(.*?\))/g
                   let re = new RegExp(question.hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX); // /\([^\(\)]+\)/g
                   if (!re.test(str)) {
                       const oneLine = str.replace(/[\r\n]/g, " @newLine ");
                       const wordArr = oneLine ? oneLine.split(" ") : [];
                       return (
                           <Fragment key={i}>
                               {wordArr.map((s, idx) => (
                                   <Fragment key={idx}>
                                       {s === '@newLine' &&
                                           <div style={{width: "100%"}}></div>
                                       }
                                       {!!s && s !== '@newLine' &&
                                           <div style={{marginRight: "5px"}}>{s}</div>
                                       }
                                   </Fragment>
                               ))}
                           </Fragment>
                       );
                   } else {
                       return (
                           <div className={`${presentPageClasses.FITBBox}`}>
                           </div>
                       );
                   }
               })}
           </span>
        );

    }



    return (
        <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={`question-${serialNo}`} style={{paddingTop: 35}}>
            {/*left portion*/}
            {renderLeftPortion()}

            {/*right portion*/}
            <div className={styles.column} style={{flex: 1, minWidth: 0, height: "100%", padding: 20, gap: 15}}>

                {/*first row*/}
                <div className={styles.row} style={{gap: 15}}>
                        <span style={{fontSize: 18, fontWeight: "500", lineHeight: "22px"}}>
                            {t("accessibility.questionPrefix")} {question.serialNo}
                        </span>

                    {questionHasWeightage(question) &&
                        <span
                            className={presentPageClasses.badge}
                            style={{width: "fit-content", padding: "0 10px", backgroundColor: "#E4E3F6"}}
                        >
                                {getQuestionWeightage(question)} {t("poll.customizePointsLabel")}
                            </span>
                    }

                    <div className={styles.row}>
                        <span className={`${classes.thumbUpIcon} ${classes.nonHover} `} style={{marginRight: 3}}/>
                        <span style={{
                            fontSize: 15,
                            fontWeight: 500,
                            color: "#4D4D4D"
                        }}> 0 </span>
                        <div style={{width: 7}}/>
                        <span className={`${classes.thumbDownIcon} ${classes.nonHover}`} style={{marginRight: 3}}/>
                        <div style={{
                            fontSize: 15,
                            fontWeight: 500,
                            color: "#4D4D4D"
                        }}> 0
                        </div>
                    </div>
                </div>

                <div className={styles.row} style={{gap: 20, alignItems: "start"}}>
                    <div className={styles.column} style={{gap: 15, flex: 1}}>
                        <div className={styles.row} style={{gap: 15}}>
                                <span style={{color: "#6B6B6B"}}>
                                    {questionCodeToName(question.questionType)}
                                </span>

                            <span style={{flex: 1}}/>
                        </div>
                        {renderTitle(question)}
                    </div>
                    {/*{!question.imageURL && !!question.directLinkEvp &&*/}
                    {/*    <iframe allowFullScreen style={{width: 270, height: 270, alignSelf: "center"}}*/}
                    {/*            src={question.directLinkEvp}/>*/}
                    {/*}*/}


                </div>

                <div style={{height: 20}}/>

                {!!question.imageURL && !question.directLinkEvp &&
                    <ImageViewer
                        width={360}
                        height={170}
                        alt={question.imageAlt}
                        imageURL={question.imageURL}
                        styles={{alignSelf: "center"}}
                    />
                }
                <div className={styles.column} style={{position: "relative", gap: 15}}>
                    {!!question.shareCount &&
                        <span
                            style={{
                                fontSize: 18,
                                fontWeight: "500",
                                width: "fit-content",
                                position: question.questionType === QUESTION_TYPES.OE.name ? "absolute" : "unset"
                            }}
                        >{t("poll.allResponsesText")}</span>
                    }


                    {!!liveResponses && (question.questionType === QUESTION_TYPES.MCSS.name
                            || question.questionType === QUESTION_TYPES.TF.name
                            || question.questionType === QUESTION_TYPES.CI.name)
                        &&
                        <ViewLiveRespCountChart
                            chartData={liveResponses}
                            showCorrectAnswer={false}
                            question={question}
                            isExpanded={true}
                            isShared={!!question.shareCount}
                            notShowAnimation={true}
                        />
                    }

                    {!!liveResponses
                        && isGeneralSA(question.questionType)
                        && !!question.shareCount
                        &&
                        <div className={classes.column} style={{gap: 10}}>
                            {!!liveResponses && liveResponses.length > 0 && liveResponses.map((response, index) =>
                                <div key={index} className={responseClasses.allResponseCard}>
                                    {response}
                                </div>
                            )}

                            {(!liveResponses || !liveResponses.length) &&
                                <>
                                    <NoResultIllustration width={130} height={71}
                                                          style={{alignSelf: "center", marginTop: 20}}/>
                                    <span style={{
                                        fontSize: 16,
                                        lineHeight: "19px",
                                        fontWeight: 600,
                                        alignSelf: "center"
                                    }}>
                                            {t("response.noResponsesYet")}
                                        </span>
                                    <span style={{
                                        fontSize: 14,
                                        lineHeight: "16px",
                                        fontWeight: 400,
                                        alignSelf: "center"
                                    }}>
                                            {t("poll.saNoResponseExplainReleasePage")}
                                        </span>
                                </>
                            }
                        </div>
                    }

                    {!!liveResponses
                        && question.questionType === QUESTION_TYPES.FITB.name
                        && !!question.shareCount
                        &&
                        <div className={styles.column} style={{gap: 10}}>
                            {liveResponses.map((response, index) =>
                                <div key={index} className={responseClasses.allResponseCard}>
                                    <div>
                                        {Object.keys(response).map((key, idx) =>
                                            <div key={idx}>- {response[key]}</div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {(!liveResponses || !liveResponses.length) &&
                                <>
                                    <NoResultIllustration width={130} height={71}
                                                          style={{alignSelf: "center", marginTop: 20}}/>
                                    <span style={{
                                        fontSize: 16,
                                        lineHeight: "19px",
                                        fontWeight: 600,
                                        alignSelf: "center"
                                    }}>
                                            {t("response.noResponsesYet")}
                                        </span>
                                    <span style={{
                                        fontSize: 14,
                                        lineHeight: "16px",
                                        fontWeight: 400,
                                        alignSelf: "center"
                                    }}>
                                            {t("poll.saNoResponseExplainReleasePage")}
                                        </span>
                                </>
                            }
                        </div>
                    }

                    {!!liveResponses
                        && question.questionType === QUESTION_TYPES.WC.name
                        && !!question.shareCount
                        &&
                        <div
                            style={{
                                alignSelf: "center",
                                width: "min(800px, 100%)",
                                height: 300,
                                backgroundColor: "#F6F6F6E6",
                                border: "1px solid #E6E6E6",
                                borderRadius: 4,
                                display: "flex", alignItems: "center", justifyContent: "center"
                            }}
                        >
                            <WordCloudResult data={liveResponses}/>
                        </div>
                    }

                    {!!liveResponses && question.questionType === QUESTION_TYPES.RK.name &&
                        <ViewLiveRespRK
                            question={question}
                            chartData={liveResponses}
                            isExpanded={true}
                            notShowAnimation={true}
                        />
                    }

                    {!!liveResponses && question.questionType === QUESTION_TYPES.MH.name &&
                        <Accordion.Root multiple className={classes.column} style={{gap: 10}} >
                            {question.correctAnswers.filter(i => i.length > 1).map((key, index) =>
                                <ViewLiveRespMH
                                    key={index}
                                    correctAnswers={question.correctAnswers}
                                    premise={key[0]}
                                    premiseIdx={index}
                                    data={liveResponses[key[0]]}
                                    shouldShowCorrect={false}
                                    isShared={!!question.shareCount}
                                    notShowAnimation={true}
                                />
                            )}
                        </Accordion.Root>
                    }

                    {!!liveResponses
                        && question.questionType === QUESTION_TYPES.OE.name
                        && !!question.shareCount
                        &&
                        <ViewLiveRespOE originalData={liveResponses}/>
                    }
                </div>
            </div>

            <div
                style={{
                    position: "absolute",
                    top: 0, left: 0,
                    width: "100%", height: 35,
                    // color: "#E9F1F3",
                    background: "#E9F1F3",
                    display: "flex", alignItems: "center",
                    fontSize: 14, lineHeight: 1.6, justifyContent: "center"
                }}
            >
                {t("poll.engageSlideTopBannerText")}
            </div>
        </div>
    );
}